"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const RadixContextMenu = __importStar(require("@radix-ui/react-context-menu"));
const constants_1 = require("../../../constants");
const Icon_1 = require("../../Icon");
const ItemContent_1 = require("../ItemContent");
const SelectedCheckmark_1 = require("../SelectedCheckmark");
const styles_1 = require("../styles");
const utils_1 = require("../utils");
const Content = (0, styled_1.default)(RadixContextMenu.Content)({
    zIndex: constants_1.theme.zIndex.popover,
    ...styles_1.panelStyles,
    ...styles_1.panelAnimation,
});
const SubContent = (0, styled_1.default)(RadixContextMenu.SubContent)({
    ...styles_1.panelStyles,
    ...styles_1.panelAnimation,
    zIndex: constants_1.theme.zIndex.popover,
});
const SubMenuWrapper = (0, styled_1.default)(RadixContextMenu.Sub)({
    zIndex: constants_1.theme.zIndex.popover,
});
const Item = (0, styled_1.default)(RadixContextMenu.Item)(styles_1.itemStyles);
const CheckboxItem = (0, styled_1.default)(RadixContextMenu.CheckboxItem)(styles_1.itemStyles);
const RadioGroup = (0, styled_1.default)(RadixContextMenu.RadioGroup)({});
const RadioItem = (0, styled_1.default)(RadixContextMenu.RadioItem)(styles_1.itemStyles);
const SubTrigger = (0, styled_1.default)(RadixContextMenu.SubTrigger)({
    ...styles_1.itemStyles,
    '&[data-state="open"]': {
        background: constants_1.Color.LIGHTEST_BLUE,
        color: constants_1.Color.CHARCOAL,
    },
});
const SubMenu = (props) => {
    return ((0, jsx_runtime_1.jsxs)(SubMenuWrapper, { children: [(0, jsx_runtime_1.jsx)(SubTrigger, { children: (0, jsx_runtime_1.jsx)(ItemContent_1.ItemContent, { icon: props.item.icon, rightSlot: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "ChevronRightIcon", size: "sm" }), children: props.item.label }) }), (0, jsx_runtime_1.jsx)(RadixContextMenu.Portal, { children: (0, jsx_runtime_1.jsx)(SubContent, { sideOffset: 4, alignOffset: -5, children: props.children }) })] }));
};
const ContextMenu = (props) => {
    return ((0, jsx_runtime_1.jsxs)(RadixContextMenu.Root, { children: [(0, jsx_runtime_1.jsx)(RadixContextMenu.Trigger, { asChild: true, disabled: props.disabled, children: props.trigger }), (0, jsx_runtime_1.jsx)(Content, { children: props.items
                    .filter((item) => !item.hidden)
                    .map((item, index) => {
                    if (item.type === 'action') {
                        return ((0, jsx_runtime_1.jsx)(Item, { onSelect: item.onClick, children: (0, jsx_runtime_1.jsx)(ItemContent_1.ItemContent, { icon: item.icon, children: item.label }) }, index));
                    }
                    if (item.type === 'sub-action') {
                        return ((0, jsx_runtime_1.jsx)(SubMenu, { item: item, children: item.subMenu.filter(utils_1.isNotHidden).map((subItem, subIndex) => ((0, jsx_runtime_1.jsx)(Item, { onSelect: subItem.onClick, children: (0, jsx_runtime_1.jsx)(ItemContent_1.ItemContent, { icon: subItem.icon, children: subItem.label }) }, subIndex))) }, index));
                    }
                    if (item.type === 'sub-checkbox') {
                        return ((0, jsx_runtime_1.jsx)(SubMenu, { item: item, children: item.subMenu.filter(utils_1.isNotHidden).map((subItem, subIndex) => {
                                const checked = item.selected.includes(subItem.value);
                                return ((0, jsx_runtime_1.jsx)(CheckboxItem, { checked: checked, onSelect: (event) => event.preventDefault(), onCheckedChange: () => item.toggleSelected(subItem.value), children: (0, jsx_runtime_1.jsx)(ItemContent_1.ItemContent, { icon: subItem.icon, rightSlot: (0, jsx_runtime_1.jsx)(SelectedCheckmark_1.SelectedCheckmark, { selected: item.selected.includes(subItem.value) }), children: subItem.label }) }, subIndex));
                            }) }, index));
                    }
                    return ((0, jsx_runtime_1.jsx)(SubMenu, { item: item, children: (0, jsx_runtime_1.jsx)(RadioGroup, { value: item.selected, onValueChange: item.onSelect, children: item.subMenu.filter(utils_1.isNotHidden).map((subItem, subIndex) => ((0, jsx_runtime_1.jsx)(RadioItem, { value: subItem.value, onSelect: (event) => event.preventDefault(), children: (0, jsx_runtime_1.jsx)(ItemContent_1.ItemContent, { icon: subItem.icon, rightSlot: (0, jsx_runtime_1.jsx)(SelectedCheckmark_1.SelectedCheckmark, { selected: subItem.value === item.selected }), children: subItem.label }) }, subIndex))) }) }, index));
                }) })] }));
};
exports.ContextMenu = ContextMenu;
